/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SnippetResponse } from './snippetResponse';

export interface SnippetListResponse {
  snippets: SnippetResponse[];
  total: number;
}
